interface VendorInformationData {
  heading?: string;
  content?: string | React.ReactNode;
}
const vendorInformationPairs: [string, React.ReactNode][] = [
  [
    "Vendor Information",
    <>
      Patients can go to one place to order blood work, refill medications, and
      schedule a video consultation with their doctor. Defy Medical will make
      sure the service is delivered as expected and with the highest level of
      customer service.
    </>,
  ],
  [
    "Pharmacy",
    <>
      <p className="mb-1">
        Progressive hormone therapies and adjunctive treatments prescribed for
        men’s and women’s health involve a variety of medications from different
        pharmacies.
      </p>
      <p className="mb-1">
        Using an expansive pharmacy network allows our providers to collaborate
        with patients on treatment options, offer extended patient choice, and
        tailor treatments to patients’ needs.
      </p>
      <p>
        Defy Medical also works to reduce costs for the patient wherever
        possible while finding the most effective medications through our
        prescription management services.
      </p>
    </>,
  ],
  [
    "Laboratory",
    <>
      <p className="mb-1">
        Laboratory assessment and early intervention to improve physiological,
        nutritional/hormonal, emotional/cognitive and physical function is key
        in running a successful practice. Routine monitoring of patient
        biomarkers is scheduled throughout the year as an essential component
        for patients receiving hormone supplementation, interventional
        therapies, and/or fertility treatments. There are certain lab tests that
        need to be performed intermittently to properly monitor patients
        undergoing hormone replacement therapies.
      </p>
      <p className="mb-1">
        Some patients do not have third-party coverage for the laboratory tests
        prescribed for these treatments; and the patient cost offered by the
        laboratory can be too expensive for the patient to afford, which
        therefore may result in non-compliance and low treatment retention.
      </p>

      <p className="mb-1">
        Defy Medical has partnered with a laboratory physician cooperative that
        contracts with accredited national laboratories to receive discounted
        prices for individual tests and test panels; the cost being
        significantly lower than what is typically billed by the laboratory.
        This cost savings is then passed to the patient, who ends up saving an
        average of 92% off the retail price.
      </p>
      <p>
        The national laboratories used by Defy Medical always uses accepted and
        proven methodologies to analyze specimens. This includes Liquid
        chromatography–mass spectrometry (LC-MS) used to accurately analyze sex
        hormones, such as Estradiol in males as LC-MS testosterone. This
        methodology is found to be more accurate than other common methods used
        by other institutions offering hormone therapies.
      </p>
    </>,
  ],
  [
    "Nutritional Supplements",
    <>
      <p className="mb-1">
        The clinic currently has wholesale contracts with several supplement
        manufacturers who produce high quality formulations for clinical use.
        These companies are a preferred source for over-the-counter supplements.
        The clinic uses these companies since they voluntarily and certifiably
        follow cGMP standards for quality control and testing as required by a
        pharmaceutical manufacturer.
      </p>
      <p>
        These contracted companies provide a great low-cost source for an array
        of nutritional supplements which can be purchased by patients. The cost
        for these nutritional supplements can possibly be lower when purchasing
        through Defy Medical, therefore the patient pays a comparable cost as
        found in retail nutrition stores but for a higher quality product.
      </p>
    </>,
  ],
  [
    "Technology",
    <>
      Defy Medical uses CFR and HIPAA compliant software to create a safe
      interactive platform that allows patients to access clinical services
      anywhere in the world.
    </>,
  ],
];
export const vendorInformationData: VendorInformationData[] =
  vendorInformationPairs.map(([heading, content]) => ({
    heading,
    content,
  }));
